export default __webpack_public_path__ + "static/media/loghi.de76cd4a.png";